// DatabaseSettingsFieldsTab.jsx

import React from 'react';

// CSS
import './DatabaseSettingsFieldsTab.css';

// Components
import TypeFields from 'collection/typefields/TypeFields';

/**
 * DatabaseSettingsFieldsTab
 *
 * Renders the fields tab content for editing database fields.
 *
 * @param {string} typeKey - Active type key from database context.
 * @param {object|null} typeDef - Active type definition object.
 * @param {string|null} baseKey - Active base key.
 *
 * @returns {ReactNode} The rendered fields tab content.
 */
const DatabaseSettingsFieldsTab = ({
  typeKey,
  typeDef,
  baseKey,
}) => {

  // ----- RENDER ----- //

  return (
    <div className="database-modal-fields">

      {/* FIELDS CONTENT */}
      <div className="database-modal-fields-content">
        <TypeFields
          typeKey={typeKey}
          typeDef={typeDef}
          baseKey={baseKey}
        />
      </div>
    </div>
  );
};

// Dev Tools
DatabaseSettingsFieldsTab.displayName = 'DatabaseSettingsFieldsTab';

export default DatabaseSettingsFieldsTab;
